import ImageCompare from "image-compare-viewer";

document.addEventListener("DOMContentLoaded", function () {
    const reviews = document.querySelectorAll(".eggo-product-reviews__card-image");
    if (reviews.length === 0) return;
    reviews.forEach(review => {
        const viewer = new ImageCompare(review, {
            smoothing:false
        }).mount();
    })
});

const initSliders = (reviews) => {
    reviews.forEach(review => sliderActions(review));
}

const sliderActions = (slider) => {
    const control = slider.querySelector("input");
    const line = slider.querySelector(".eggo-product-reviews__card-slider-line");
    const button = slider.querySelector(".eggo-product-reviews__card-slider-button");
    const clipImage = slider.querySelector(".eggo-product-reviews__card-image--before-wrap");
    setSliderValues(control,line, button, clipImage, control.value);
    control.addEventListener("input", () => {
        setSliderValues(control,line, button, clipImage, control.value);
    });
}

const setSliderValues = (control,line, button, clipImage, percentageValue) => {
    const percentage = percentageValue + "%";
    const sliderOffset = 128 * (percentageValue - 50) / 100 + "px";
    line.style.left = `calc(${percentage} - 1px)`;
    button.style.left = `calc(${percentage} - 34px)`;
    clipImage.style.clipPath = `polygon(0 0, ${percentage} 0, ${percentage} 100%, 0% 100%)`;
    control.style.setProperty('--sliderOffset', sliderOffset);
}